export const ContactData = [
    {
        title: 'LinkedIn',
        link: 'https://www.linkedin.com/in/gabrielssalves'
    },
    {
        title: 'Github',
        link: 'https://github.com/Gabrielssalves'
    },
    {
        title: 'Email',
        link: 'mailto:gabrielssalves97@gmail.com'
    }
]
